// extracted by mini-css-extract-plugin
module.exports = {"TimeSelect":"TimeSelect_TimeSelect__2lKFI","lastVacancies":"TimeSelect_lastVacancies__fSHMO"};